import { useEffect, useState, useCallback } from "react";

import type { Tenant } from "@chirpstack/chirpstack-api-grpc-web/api/tenant_pb";
import type { LogItem } from "@chirpstack/chirpstack-api-grpc-web/api/internal_pb";
import { StreamTenantIntegrationEventsRequest } from "@chirpstack/chirpstack-api-grpc-web/api/internal_pb";

import InternalStore from "../../stores/InternalStore";
import IntegrationEventTable from "../../components/IntegrationEventTable";

function TenantIntegrationEvents({ tenant }: { tenant: Tenant }) {
  const [logs, setLogs] = useState<LogItem[]>([]);

  const onMessage = useCallback((l: LogItem) => {
    setLogs(e => {
      if (e.length === 0 || parseInt(l.getId().replace("-", "")) > parseInt(e[0].getId().replace("-", ""))) {
        return [l, ...e];
      }
      return e;
    });
  }, []);

  useEffect(() => {
    const req = new StreamTenantIntegrationEventsRequest();
    req.setTenantId(tenant.getId());
    return InternalStore.streamTenantIntegrationEvents(req, onMessage);
  }, [tenant, onMessage]);

  return <IntegrationEventTable logs={logs} />;
}

export default TenantIntegrationEvents;
